import { render, staticRenderFns } from "./ReportCheckbox.vue?vue&type=template&id=6c195245&scoped=true"
import script from "./ReportCheckbox.vue?vue&type=script&lang=js"
export * from "./ReportCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ReportCheckbox.vue?vue&type=style&index=0&id=6c195245&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c195245",
  null
  
)

export default component.exports